import { NextSeo } from 'next-seo';
import { Fragment } from 'react';
import { LazyLoad } from 'react-observer-api';
import axios from 'axios';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Splitter from '../../components/Splitter';
import BuildingGreeting from '../../components/building/BuildingGreeting';
import BuildingFlags from '../../components/building/BuildingFlags';
import BuildingInformation from '../../components/building/BuildingInformation';
import BuildingMap from '../../components/building/BuildingMap';
import BuildingProgress from '../../components/building/BuildingProgress';
import BuildingBanner from '../../components/building/BuildingBanner';
import BuildingObjects from '../../components/building/BuildingObjects';

const getPrice = (p) => {
  const priceMin = Number((p.min / 1000000).toFixed(1));
  const priceMax = Number((p.max / 1000000).toFixed(1));

  if (priceMin === priceMax) return `от ${priceMin} млн ₽`;

  return `от ${priceMin} млн ₽ до ${priceMax} млн ₽`;
};
const cityCase = (ct) =>
  ({
    'Ростов-на-Дону': 'Ростове-на-Дону',
    Новочеркаск: 'Новочеркаске',
    Батайск: 'Батайске',
    Аксай: 'Аксае',
    Азов: 'Азове',
    Таганрог: 'Таганроге'
  })[ct] || ct;

const BuildingPage = ({ id, data }) => {
  return (
    <Fragment>
      <NextSeo
        title={`Купить квартиру в новостройке ЖК "${data['building-name']}" в ${cityCase(
          data.location['locality-name']
        )}`}
        description={`Купите квартиру в новостройке в ЖК "${data['building-name']}" ${getPrice(
          data.price
        )}`}
        openGraph={{
          url: `https://landlord.ru/building/${id}`,
          type: 'website',
          title: `ЖК "${data['building-name']}" в ${cityCase(data.location['locality-name'])}`,
          description: `Купите квартиру в ЖК "${data['building-name']}" ${getPrice(data.price)}`,
          images: [
            {
              url: data.images[0]
            }
          ],
          site_name: 'LANDLORD'
        }}
      />
      <Header />
      <main>
        <BuildingGreeting
          name={data['building-name']}
          image={data.images[0]}
          price={data.price}
          location={data.location}
        />
        <BuildingFlags data={data} />
        <BuildingInformation data={data} />
        <BuildingBanner
          title={['Цены с комиссией?', 'Цены от застройщика!']}
          text={[
            'Наши специалисты совершенно бесплатно помогут Вам с подбором квартиры в новостройке в удобное для Вас время'
          ]}
          button="Оставить заявку"
        />
        <BuildingObjects rooms={Object.keys(data.rooms)} buildings={data.buildings} />
        <LazyLoad>
          <BuildingMap buildings={data.buildings} />
          {!!data.constructionProgress.length && (
            <BuildingProgress progress={data.constructionProgress} />
          )}
        </LazyLoad>
      </main>
      <Splitter
        title="Помочь c подбором?"
        subtitle="Оставьте свой номер телефона и мы обязательно подберем лучшие варианты!"
      />
      <Footer />
    </Fragment>
  );
};

export async function getServerSideProps({ query }) {
  const response = await axios.post(process.env.NEXT_PUBLIC_API + '/buildings', {
    complex: query.id
  });

  if (!response.data || response.data.status !== 'ok' || !response.data.data.data[0]) {
    return {
      notFound: true
    };
  }

  return {
    props: {
      id: query.id,
      data: response.data.data.data[0]
    }
  };
}

export default BuildingPage;
